import { logError } from '../../helpers/logger';

import type { ContextHeaderData } from '@web-platform/shared-universal-types/src/context';
import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

type HeaderData = Nullable<ContextHeaderData>;

let headerData: HeaderData = null;

export const setHeaderData = (newHeaderData: HeaderData) => {
  headerData = newHeaderData;
};

export const getHeaderData = () => {
  if (headerData === null) {
    const error = new Error('Header data is not set.');
    logError({
      error,
      component: 'GlobalHeader',
      message: 'Error getting header data',
    });
  }
  return headerData;
};
